// extracted by mini-css-extract-plugin
module.exports = {"textArea":"textArea_textArea__2I4ZP","FormItem":"textArea_FormItem__3xpg8"};